module.exports = "*:not(.fa) {\n  font-family: \"Cairo\", sans-serif;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/financial/claims-view/modals/add-claim-form-modal/add-claim-form-modal.component.css
// module id = ./src/app/financial/claims-view/modals/add-claim-form-modal/add-claim-form-modal.component.css
// module chunks = main